import { render } from "./SmartAddress.vue?vue&type=template&id=3b6f0343"
import script from "./SmartAddress.vue?vue&type=script&lang=js"
export * from "./SmartAddress.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/proship-public-order/proship-public-order/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__